import _ from "lodash";
import { InitialSettings, Settings } from "../Interfaces";

/**
 * @description get setting types from setting list
 * @param {Array<Settings>} settingList setting list
 * @returns {Array<string>} setting types
 */

export const getSettingTypeList = (
  settingList: Array<Settings>
): Array<string> => {
  try {
    if (Array.isArray(settingList) && settingList.length > 0) {
      const uniqueTypes = _.uniqBy(settingList, "settingType").map(
        (item) => item.settingType
      );
      return uniqueTypes;
    } else return [];
  } catch (error) {
    return [];
  }
};

/**
 * @description get setting modified list
 * @param {Array<InitialSettings>} settingList setting list
 * @returns {Array<Settings>} modified settings
 */

export const getSettingModifiedList = (
  settingList: Array<InitialSettings>
): Array<Settings> => {
  try {
    if (Array.isArray(settingList) && settingList.length > 0) {
      return settingList.map((item: any) =>
        item.isPassword
          ? {
              ...item,
              showPassword: false,
            }
          : item
      );
    } else return [];
  } catch (error) {
    return [];
  }
};

/**
 * @description set password visibility
 * @param {Array<InitialSettings>} settingList setting list
 * @param {string} settingName setting name
 * @returns {Array<Settings>} modified settings
 */

export const setPasswordVisibility = (
  settingList: Array<InitialSettings>,
  settingName: string
): Array<Settings> => {
  try {
    if (Array.isArray(settingList) && settingList.length > 0) {
      return settingList.map((item: any) =>
        item.settingName == settingName
          ? {
              ...item,
              showPassword: !item.showPassword,
            }
          : item
      );
    } else return [];
  } catch (error) {
    return [];
  }
};

/**
 * @description get filtered setting list by setting type
 * @param {Array<Settings>} settingList setting list
 * @param {string} settingType setting type
 * @returns {Array<Settings>} filtered list
 */

export const getSettingsByType = (
  settingList: Array<Settings>,
  settingType: string
): Array<Settings> => {
  try {
    if (Array.isArray(settingList) && settingList.length > 0) {
      return settingList.filter(
        (setting) => setting.settingType == settingType
      );
    } else return [];
  } catch (error) {
    return [];
  }
};

/**
 * @description get filtered setting list for initial formik values
 * @param {Array<Settings>} settingList setting list
 * @returns { [key: string]: any } filtered list
 */

export const getInitialValues = (
  settingList: Array<Settings>
): { [key: string]: any } => {
  try {
    if (Array.isArray(settingList) && settingList.length > 0) {
      return settingList.reduce((object, setting) => {
        object[setting.settingName] = setting.settingValue;
        return object;
      }, {} as { [key: string]: any });
    } else return {};
  } catch (error) {
    return {};
  }
};

/**
 * @description get modified settings for update
 * @param {Array<Settings>} initialList initial setting list
 * @param {any} modifiedFormValues modified setting list
 * @returns { any } filtered list
 */

export const getModifiedListForUpdate = (
  initialList: Array<Settings>,
  modifiedFormValues: any
): any => {
  try {
    if (
      modifiedFormValues &&
      Array.isArray(initialList) &&
      initialList.length > 0
    ) {
      return initialList
        .map((setting: Settings) => {
          if (setting.settingValue != modifiedFormValues[setting.settingName]) {
            return {
              settingId: setting.settingId,
              settingValue: modifiedFormValues[setting.settingName],
            };
          }
        })
        .filter((setting: any) => setting !== undefined);
    } else return [];
  } catch (error) {
    return [];
  }
};
